import {dictionaryContainer} from "@/util/common/dictionary";
import PueDaily from "@/api/pue/pue-daily";

export default {

    namespaced: true,

    state: {
        currentRowId: null,
        visitedIds: [],

        pageSearch: {
            current: 1,
            size: 10,
            search: {
                eq_roomId: null,
                eq_recordSource: null,
                range_tsdate: null,
            },
        },
        page: {
            total: 0,
            records: []
        },
    },

    getters: {
        currentRowId(state) {
            return state.currentRowId;
        },
        visitedIds(state) {
            return state.visitedIds;
        },
        pageSearch(state) {
            return state.pageSearch;
        },
        page(state) {
            return state.page;
        },
    },

    mutations: {
        setCurrentRowId(state, currentRowId) {
            state.currentRowId = currentRowId;
        },
        addVisitedId(state, currentRowId) {
            if (currentRowId != null) {
                let visitedIds = state.visitedIds;
                let existed = false;
                for (let i = 0, len = visitedIds.length; i < len; i++) {
                    if (visitedIds[i] === currentRowId) {
                        existed = true;
                        break;
                    }
                }
                if (!existed) {
                    visitedIds.push(currentRowId);
                }
            }
        },
        removeVisitedId(state, currentRowId) {
            if (currentRowId != null) {
                let visitedIds = state.visitedIds;
                let index = -1;
                for (let i = 0, len = visitedIds.length; i < len; i++) {
                    if (visitedIds[i] === currentRowId) {
                        index = i;
                        break;
                    }
                }
                if (index > -1) {
                    visitedIds.splice(index, 1);
                }
            }
        },
        setPageSearch(state, pageSearch) {
            state.pageSearch = pageSearch;
        },
        setPageSearchCurrent(state, current) {
            state.pageSearch.current = current;
        },
        setPageSearchSize(state, size) {
            state.pageSearch.size = size;
        },
        setPageSearchSearch(state, search) {
            state.pageSearch.search = search;
        },
        setPageSearchSearchEqRoomId(state, roomId) {
            state.pageSearch.search.eq_roomId = roomId;
        },
        setPageSearchSearchEqRecordSource(state, recordSource) {
            state.pageSearch.search.eq_recordSource = recordSource;
        },
        setPageSearchSearchRangeTsDate(state, rangeTsDate) {
            state.pageSearch.search.range_tsdate = rangeTsDate;
        },
        setPage(state, page) {
            state.page = page;
        },
    },

    actions: {
        async doQueryByPage({commit}, pageSearch) {
            //pageSearch = pageSearch || JSON.parse(JSON.stringify(state.list.pageSearch));
            // 数据中心范围
            let roomDictionary = await dictionaryContainer.getDictionary('room', {type: 'AUTH_SITE'});
            pageSearch.search.in_roomId = roomDictionary.getValues();
            // 日期范围
            let gtTsDate, ltTsDate;
            let rangeTsDate = pageSearch.search.range_tsdate;
            if (rangeTsDate != null && rangeTsDate.length === 2) {
                gtTsDate = rangeTsDate[0];
                ltTsDate = rangeTsDate[1];
            } else {
                gtTsDate = null;
                ltTsDate = null;
            }
            pageSearch.search.gt_tsdate = gtTsDate;
            pageSearch.search.lt_tsdate = ltTsDate;
            // 查询
            PueDaily.page(pageSearch).then(res => {
                if (res.data.success) {
                    let records = res.data.data.records;
                    if (records.length === 0 && pageSearch.current > 1) {
                        commit('setPageSearchCurrent', pageSearch.current - 1);
                    } else {
                        commit('setPage', res.data.data);
                    }
                }
            });
        },
    },

}